import { usePage } from '@inertiajs/react'

import { Container, Title, Text, Stack } from '@mantine/core'
import StationLists from '../_StationLists'
import { ListCard, ListRow } from '../../_ListCard'
import Seo from '../../_Seo'
import { breadcrumbList } from '../../_structuredData'
import { useI18n } from '../../_i18n'
import { useLocalePath } from '../../_localePath'

export default function CountryPage({ country }) {
  const { t } = useI18n()
  const localePath = useLocalePath()
  const c = country || {}
  const stateTerm = c.state_term || t('states')
  const states = c.states || []
  const tide = c.tide_stations || []
  const current = c.current_stations || []
  const { site_url: siteUrl = '' } = usePage().props

  const hasContent = states.length || tide.length || current.length

  return (
    <>
      <Seo
        title={t('location_title', { name: c.name })}
        description={t('country_seo_description', { name: c.name, stateTerm })}
        jsonLd={breadcrumbList(siteUrl, [
          { name: c.name, path: localePath(`/countries/${c.permalink}`) },
        ])}
      />
      <Container size="md" py="xl">
        <Title order={1} mb="lg">
          {c.name}
        </Title>

        <Stack gap="md">
          {states.length > 0 && (
            <ListCard title={stateTerm}>
              {states.map((s) => (
                <ListRow key={s.id} href={localePath(`/states/${s.permalink}`)} name={s.name} />
              ))}
            </ListCard>
          )}
          <StationLists tideStations={tide} currentStations={current} />
          {!hasContent && <Text c="dimmed">{t('no_stations_found_location')}</Text>}
        </Stack>
      </Container>
    </>
  )
}
